<button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger">
  <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #userMenu="matMenu" [overlapTrigger]="false">
  <!-- class="toolbar-dropdown-menu user-menu"> -->
  <!--<span (mouseleave)="userMenuTrigger.closeMenu()">-->
  <button mat-menu-item>{{ currentUser()?.firstName }} {{ currentUser()?.lastName }}</button>
  <!--
  <mat-card class="user-info-flex user-info p-0">
    <img *ngIf="currentUser" [src]="currentUser.imageUrl" alt="user-image">
    <div class="user-info-details-flex">
      <h2>{{currentUser.firstName}} {{currentUser.lastName}}</h2>
      <h2>{{currentUser.userName}}</h2>
    </div>
  </mat-card>
  -->
  <mat-divider></mat-divider>
  @if (isInRole(enums.role.shiftAdmin) || isInRole(enums.role.shiftAnalyst) || isInRole(enums.role.corporate)) {
    <a mat-menu-item (click)="editProfile()">
      <mat-icon>person</mat-icon>
      <span>Profile</span>
    </a>
  }
  <!--<a mat-menu-item (click)="editProfile()">
  <mat-icon>settings</mat-icon>
  <span>Settings</span>
</a>-->
  <!--<a mat-menu-item routerLink="/">
<mat-icon>lock</mat-icon>
<span>Lock screen</span>
</a>-->
  <a mat-menu-item routerLink="help">
    <mat-icon>help</mat-icon>
    <span>Help</span>
  </a>
  <!--<mat-divider></mat-divider>-->
  <a mat-menu-item (click)="logout()">
    <mat-icon>power_settings_new</mat-icon>
    <span>Logout</span>
  </a>
</mat-menu>
